import React from 'react'
import BlogGridsContainer from '../../../../Components/Miscellaneous/Blog/BlogGrids'

export default function BlogGrids() {
  return (
    <div className='page-body'>
        <BlogGridsContainer/>
    </div>
  )
}
